var map = {
	"./Icons/360.svg": 96688,
	"./Icons/Knowledge.svg": 4237,
	"./Icons/Office map.svg": 86981,
	"./Icons/Onboarding.svg": 15076,
	"./Icons/Questions.svg": 40362,
	"./Icons/Services.svg": 58323,
	"./Icons/TaskTracker.svg": 25740,
	"./Icons/blank_document.svg": 87121,
	"./Icons/charts.svg": 68428,
	"./Icons/connectableIcon_32.svg": 64328,
	"./Icons/default_file.svg": 58883,
	"./Icons/files/docx.svg": 52553,
	"./Icons/files/image.svg": 59530,
	"./Icons/files/jpeg.svg": 95429,
	"./Icons/files/jpg.svg": 52420,
	"./Icons/files/mp3.svg": 71903,
	"./Icons/files/mp4.svg": 22368,
	"./Icons/files/pdf.svg": 76843,
	"./Icons/files/pdf2.svg": 79475,
	"./Icons/files/pptx.svg": 14111,
	"./Icons/files/psd.svg": 56596,
	"./Icons/files/xlsx.svg": 82066,
	"./Icons/filled_doc.svg": 77544,
	"./Icons/intranetableIcon_32.svg": 54019,
	"./Icons/ok_50.svg": 31747,
	"./content-icons/align-center.svg": 84276,
	"./content-icons/align-left.svg": 28768,
	"./content-icons/align-right.svg": 73967,
	"./content-icons/delete.svg": 61842,
	"./content-icons/float-left.svg": 72583,
	"./content-icons/float-right.svg": 88610,
	"./icons_new/6_dots.svg": 40475,
	"./icons_new/6_dots_vert.svg": 3935,
	"./icons_new/R_coin.svg": 55696,
	"./icons_new/add_column_after.svg": 70911,
	"./icons_new/add_row_after.svg": 52637,
	"./icons_new/add_to_queue.svg": 97897,
	"./icons_new/alarm.svg": 74521,
	"./icons_new/at.svg": 81,
	"./icons_new/bar_top.svg": 6377,
	"./icons_new/calendar.svg": 55352,
	"./icons_new/calendar_calendar.svg": 50925,
	"./icons_new/calendar_check.svg": 14293,
	"./icons_new/calendar_event.svg": 46381,
	"./icons_new/calendar_x.svg": 22485,
	"./icons_new/chat.svg": 11432,
	"./icons_new/chat_2.svg": 69439,
	"./icons_new/chat_alt.svg": 59628,
	"./icons_new/check.svg": 79922,
	"./icons_new/check_all.svg": 29546,
	"./icons_new/check_all_big.svg": 50345,
	"./icons_new/check_big.svg": 55857,
	"./icons_new/check_bold.svg": 53068,
	"./icons_new/checkbox.svg": 7041,
	"./icons_new/checkbox_checked.svg": 33639,
	"./icons_new/checklist_alt.svg": 88582,
	"./icons_new/chevron_big_down.svg": 67419,
	"./icons_new/chevron_big_left.svg": 42652,
	"./icons_new/chevron_big_right.svg": 70499,
	"./icons_new/chevron_big_up.svg": 34548,
	"./icons_new/chevron_down.svg": 68262,
	"./icons_new/chevron_duo_down.svg": 93837,
	"./icons_new/chevron_duo_left.svg": 22422,
	"./icons_new/chevron_duo_right.svg": 36437,
	"./icons_new/chevron_duo_up.svg": 32658,
	"./icons_new/chevron_left.svg": 82957,
	"./icons_new/chevron_right.svg": 58032,
	"./icons_new/chevron_up.svg": 49469,
	"./icons_new/circle_check.svg": 87407,
	"./icons_new/circle_check_outline.svg": 78928,
	"./icons_new/circle_chevron_down.svg": 58669,
	"./icons_new/circle_chevron_right.svg": 26005,
	"./icons_new/circle_chevron_up.svg": 9426,
	"./icons_new/circle_down.svg": 1853,
	"./icons_new/circle_right.svg": 81317,
	"./icons_new/clip.svg": 84608,
	"./icons_new/clock.svg": 51112,
	"./icons_new/close16.svg": 36311,
	"./icons_new/close_big.svg": 18813,
	"./icons_new/close_small.svg": 54498,
	"./icons_new/cloud_check.svg": 91388,
	"./icons_new/cloud_down.svg": 45216,
	"./icons_new/cloud_up.svg": 54195,
	"./icons_new/colored_folder.svg": 37871,
	"./icons_new/commented.svg": 37206,
	"./icons_new/comments.svg": 77368,
	"./icons_new/copy.svg": 4393,
	"./icons_new/cross.svg": 60834,
	"./icons_new/cupcake.svg": 33578,
	"./icons_new/curr-EUR.svg": 97261,
	"./icons_new/curr-RUB.svg": 74170,
	"./icons_new/curr-UAH.svg": 1555,
	"./icons_new/curr-USD.svg": 23405,
	"./icons_new/download.svg": 50906,
	"./icons_new/dropdown_arrow.svg": 45819,
	"./icons_new/dropdown_arrow_up.svg": 1733,
	"./icons_new/edit.svg": 31782,
	"./icons_new/edit_white.svg": 34552,
	"./icons_new/excel.svg": 12899,
	"./icons_new/exit.svg": 12762,
	"./icons_new/external_link.svg": 28754,
	"./icons_new/file_blank_fill.svg": 60925,
	"./icons_new/file_blank_outline.svg": 45900,
	"./icons_new/file_minus.svg": 67605,
	"./icons_new/filter_outline.svg": 39679,
	"./icons_new/flag.svg": 95608,
	"./icons_new/flag_outline.svg": 30007,
	"./icons_new/folder.svg": 40002,
	"./icons_new/folder_open.svg": 71413,
	"./icons_new/folder_plus.svg": 30989,
	"./icons_new/group.svg": 41699,
	"./icons_new/hamburger.svg": 12411,
	"./icons_new/happy.svg": 67248,
	"./icons_new/heart_fill.svg": 42458,
	"./icons_new/heart_outline.svg": 41697,
	"./icons_new/help_circle.svg": 16742,
	"./icons_new/help_circle_outline.svg": 41369,
	"./icons_new/help_questionmark.svg": 44961,
	"./icons_new/home_alt_fill.svg": 46853,
	"./icons_new/home_alt_outline.svg": 40564,
	"./icons_new/home_heart.svg": 36434,
	"./icons_new/id_card.svg": 20558,
	"./icons_new/jpg.svg": 58539,
	"./icons_new/label.svg": 15676,
	"./icons_new/like.svg": 86967,
	"./icons_new/liked.svg": 64025,
	"./icons_new/link.svg": 55978,
	"./icons_new/linkedin.svg": 71060,
	"./icons_new/list_checklist_alt.svg": 31775,
	"./icons_new/loader-resize.svg": 48924,
	"./icons_new/loader_64.svg": 46416,
	"./icons_new/loading-90.svg": 2428,
	"./icons_new/loading.svg": 21974,
	"./icons_new/loading_pic.svg": 61287,
	"./icons_new/location.svg": 22679,
	"./icons_new/location_outline.svg": 63048,
	"./icons_new/log_out.svg": 68657,
	"./icons_new/mail.svg": 79679,
	"./icons_new/map.svg": 59760,
	"./icons_new/menu_duo.svg": 90298,
	"./icons_new/message.svg": 78671,
	"./icons_new/minus.svg": 97870,
	"./icons_new/moon.svg": 19585,
	"./icons_new/more_horizontal.svg": 97928,
	"./icons_new/more_vertical.svg": 43070,
	"./icons_new/music.svg": 95303,
	"./icons_new/notification.svg": 83287,
	"./icons_new/notification_dot.svg": 71527,
	"./icons_new/notification_outline.svg": 1832,
	"./icons_new/off_close.svg": 43640,
	"./icons_new/off_outline_close.svg": 92231,
	"./icons_new/off_outline_close_grey.svg": 28459,
	"./icons_new/paperclip.svg": 14810,
	"./icons_new/pause_circle_outline.svg": 34772,
	"./icons_new/phone.svg": 24546,
	"./icons_new/pin.svg": 47575,
	"./icons_new/pin_outline.svg": 71752,
	"./icons_new/play_arrow.svg": 57778,
	"./icons_new/play_circle_filled.svg": 62762,
	"./icons_new/plus.svg": 37734,
	"./icons_new/plus_circle_outline.svg": 30522,
	"./icons_new/radio.svg": 2775,
	"./icons_new/radio_filled.svg": 58022,
	"./icons_new/redo.svg": 37458,
	"./icons_new/refresh.svg": 18103,
	"./icons_new/refresh_02.svg": 91632,
	"./icons_new/search.svg": 84082,
	"./icons_new/search_small.svg": 33990,
	"./icons_new/search_small_minus.svg": 59039,
	"./icons_new/search_small_plus.svg": 58961,
	"./icons_new/settings.svg": 39425,
	"./icons_new/settings_filled.svg": 3252,
	"./icons_new/share.svg": 16183,
	"./icons_new/share_outline.svg": 25832,
	"./icons_new/short_down.svg": 69495,
	"./icons_new/short_left.svg": 38696,
	"./icons_new/short_right.svg": 38263,
	"./icons_new/short_up.svg": 53384,
	"./icons_new/show.svg": 36921,
	"./icons_new/shrink.svg": 32861,
	"./icons_new/small_down.svg": 79458,
	"./icons_new/star.svg": 62178,
	"./icons_new/star_empty.svg": 13624,
	"./icons_new/stopwatch.svg": 52247,
	"./icons_new/struct_tree.svg": 46596,
	"./icons_new/sun.svg": 24272,
	"./icons_new/superstar.svg": 62563,
	"./icons_new/table.svg": 61734,
	"./icons_new/table_cell_split.svg": 88316,
	"./icons_new/table_col_header.svg": 98087,
	"./icons_new/table_drop.svg": 74706,
	"./icons_new/table_header.svg": 21346,
	"./icons_new/table_next_cell.svg": 41677,
	"./icons_new/tag-outline.svg": 25243,
	"./icons_new/telegram.svg": 61507,
	"./icons_new/text_align_left.svg": 74987,
	"./icons_new/transfer.svg": 23095,
	"./icons_new/trash_empty.svg": 8782,
	"./icons_new/trash_full.svg": 63776,
	"./icons_new/tree.svg": 95606,
	"./icons_new/twitter.svg": 99331,
	"./icons_new/undo.svg": 74500,
	"./icons_new/unfold_more.svg": 92710,
	"./icons_new/up_down.svg": 39336,
	"./icons_new/user.svg": 42627,
	"./icons_new/user_check.svg": 41406,
	"./icons_new/user_circle.svg": 9718,
	"./icons_new/user_close.svg": 91962,
	"./icons_new/user_minus.svg": 76538,
	"./icons_new/user_plus.svg": 70674,
	"./icons_new/users_group.svg": 89654,
	"./icons_new/vk.svg": 18667,
	"./icons_new/warning.svg": 38822,
	"./icons_new/whatsapp.svg": 47636,
	"./icons_new/window.svg": 53446,
	"./images/ImageEmptyConnectable.svg": 77041,
	"./images/ImageEmptyIntra.svg": 40283,
	"./images/LogoDots.svg": 49710,
	"./images/MainLogo.svg": 17953,
	"./images/MainLogoLight.svg": 12231,
	"./images/VideoPoster2.svg": 50223,
	"./images/VideoPosterConn.svg": 31437,
	"./images/VideoPosterIntra.svg": 64141,
	"./images/VideoPoster_disabled.svg": 91266,
	"./images/access_all.svg": 42009,
	"./images/access_city.svg": 3349,
	"./images/access_department.svg": 39514,
	"./images/access_head.svg": 12518,
	"./images/access_manual.svg": 40930,
	"./images/access_name.svg": 54521,
	"./images/access_time.svg": 53643,
	"./images/alert_icon_error.svg": 53086,
	"./images/alert_icon_info.svg": 35688,
	"./images/alert_icon_question.svg": 50312,
	"./images/alert_icon_success.svg": 50733,
	"./images/alert_icon_warning.svg": 7400,
	"./images/b24_angry.svg": 44767,
	"./images/b24_facepalm.svg": 62331,
	"./images/b24_haha.svg": 60368,
	"./images/b24_like.svg": 53065,
	"./images/b24_love.svg": 28984,
	"./images/b24_sad.svg": 93628,
	"./images/b24_wow.svg": 66577,
	"./images/dots.svg": 77663,
	"./images/empties/empty_address_book.svg": 91599,
	"./images/empties/empty_groups.svg": 19547,
	"./images/empties/empty_kb.svg": 23076,
	"./images/empties/empty_polls.svg": 48935,
	"./images/empties/empty_services.svg": 76899,
	"./images/empties/empty_vacancies.svg": 75606,
	"./images/intranetable_logo.svg": 11880,
	"./images/intranetable_logo_bord.svg": 66320,
	"./images/sendsay.svg": 53074,
	"./images/sendsay_logo.svg": 64687,
	"./images/ya-music-ru-white_v2023.svg": 3699,
	"./logo.svg": 63935,
	"./pics/EmptyState.svg": 85578,
	"./pics/baseball_player_success.svg": 56312,
	"./pics/blank_doc_48.svg": 44000,
	"./pics/colored_folder.svg": 95025,
	"./pics/colored_folder_blue.svg": 62440,
	"./pics/customer_support.svg": 81052,
	"./pics/error_service.svg": 24078,
	"./pics/fast_speed_success.svg": 31422,
	"./pics/idea_main.svg": 77983,
	"./pics/polls/Advertise.svg": 34540,
	"./pics/polls/Chat.svg": 86159,
	"./pics/polls/Coworking.svg": 79864,
	"./pics/polls/Data analyse.svg": 5454,
	"./pics/polls/Hirerring.svg": 19765,
	"./pics/polls/Startup.svg": 15660,
	"./pics/polls/Study online.svg": 51141,
	"./pics/polls/Work  abroad.svg": 75305,
	"./pics/polls/start.svg": 47139,
	"./sidebar/addressBook.svg": 74084,
	"./sidebar/calendar.svg": 99259,
	"./sidebar/chat_alt.svg": 16423,
	"./sidebar/groups.svg": 34729,
	"./sidebar/home.svg": 43152,
	"./sidebar/inbox.svg": 20979,
	"./sidebar/library.svg": 69106,
	"./sidebar/meh.svg": 75933,
	"./sidebar/message-circle.svg": 84483,
	"./sidebar/notifications.svg": 52407,
	"./sidebar/pie-chart.svg": 9030,
	"./sidebar/profile.svg": 31212,
	"./sidebar/server.svg": 44608,
	"./sidebar/settings.svg": 83562,
	"./sidebar/shop.svg": 41309,
	"./sidebar/tree.svg": 32973,
	"./sidebar/users.svg": 19939,
	"./sidebar/zap.svg": 18198,
	"./socials/facebook.svg": 86349,
	"./socials/facebook_invert.svg": 1204,
	"./socials/instagram.svg": 19495,
	"./socials/instagram_invert.svg": 20138,
	"./socials/linkedin.svg": 56499,
	"./socials/linkedin_invert.svg": 31958,
	"./socials/skype.svg": 96789,
	"./socials/skype_invert.svg": 14300,
	"./socials/telegram.svg": 6452,
	"./socials/telegram_invert.svg": 26263,
	"./socials/tiktok.svg": 72127,
	"./socials/tiktok_invert.svg": 50530,
	"./socials/twitter.svg": 16682,
	"./socials/twitter_invert.svg": 66241,
	"./socials/whatsapp.svg": 83247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;